import React, { useState } from 'react';

export default function Selector({
  count,
  title,
  subtitle,
  selectedValue,
  onChangeHandler,
  nullValue = 0,
  nullText = 'Select a store',
  icon = '',
  options = [],
}: {
  count: number;
  title: string;
  subtitle: string;
  selectedValue: string | number;
  onChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  nullValue?: string | number;
  nullText?: string;
  icon?: string;
  options?: { value: string | number; name: string }[];
}) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div
      className="
                          bg-secondary-100
                          p-[20px]
                          rounded-[5px]
                          relative
                          "
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="
                bg-transparent
                absolute top-[14px] right-[0px] text-secondary-500 
                focus:outline-none
                focus:ring-0
                focus:border-0
                focus:outline-none transition-colors"
        aria-label={
          isOpen ? 'Hide select and subtitle' : 'Show select and subtitle'
        }
      >
        {isOpen ? (
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 15l7-7 7 7"
            />
          </svg>
        ) : (
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
      </button>

      <div
        className="
                            flex
                            items-center
                            gap-[10px]
                            pr-[30px]
                            "
      >
        {count && (
          <div
            className="
                                bg-secondary-500 
                                w-[30px]
                                h-[30px]
                                rounded-full
                                text-white
                                font-bold
                                text-[12px]
                                flex items-center justify-center
                              "
          >
            {count}
          </div>
        )}
        <div>
          {title && (
            <div
              className="block text-sm 
                              font-semibold 
                              text-secondary-500
                              !text-[18px]
                              "
            >
              {title}
            </div>
          )}
          {isOpen && subtitle && (
            <div
              className="
                                text-gray-700
                                text-[12px]  
                                font-medium
                              "
            >
              {subtitle}
            </div>
          )}
        </div>
      </div>

      {isOpen && (
        <div
          className="mt-5 border-[1px] border-gray-200 
                              flex gap-[5px] bg-white px-3
                              rounded-md"
        >
          <div
            className="
                                      w-[30px] h-[40px] 
                                      flex items-center justify-center"
          >
            {icon && (
              <img src={icon} className="w-[18px] object-cover" alt="map pin" />
            )}
          </div>
          <select
            className="w-full font-dmsans p-[10px] rounded-md bg-white text-primary-800 
                                    text-[13px] hover:outline-none 
                                    focus:outline-none focus:ring-0
                                  "
            value={selectedValue}
            name="store"
            // disabled={percentageComplete < 50}
            onChange={onChangeHandler}
          >
            <option value={nullValue}>{nullText}</option>

            {options &&
              options.length > 0 &&
              options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
          </select>
        </div>
      )}
    </div>
  );
}
